function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.083 25.583c0-1.805-.526-2.583-2.47-2.583H12v5h5a2.38 2.38 0 0 0 2.083-2.417zM17.188 33H12v6h4.7c2.754 0 4.053-1.135 4.053-3.08.002-2.108-1.297-2.92-3.565-2.92z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 6v50h32V6zm17.853 38H6V18h11.262c5.317 0 8.422 2.51 8.422 6.647a6.308 6.308 0 0 1-3.548 5.467c2.07.737 4.285 2.512 4.285 6.5 0 4.135-3.25 7.386-8.567 7.386zM72 0v18h10.967c5.017 0 8.852 2.217 8.852 7.387a8.384 8.384 0 0 1-4.575 7.68L93 43.558V44h-7.488l-4.535-9H78v9h-6v18h56V0zm51 44h-7.11L106 28.858V44h-7V18h7.11L116 33.326V18h7z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M85 26.424C85 23.892 83.81 23 81.13 23H78v7h4.618A3.935 3.935 0 0 0 85 26.424zM43.35 34h5.96l-2.942-10.134L43.348 34"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M41 13v11.366L43.118 18h7.794L59 43.632V44h-6.765l-1.25-4H42.16L41 43.718V49h22V13H41M137 13v5h17v5h-10v5h9v5h-9v6h11v5h-18v5h22V13h-22"
});

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M178.853 36.394c0-1.64-.745-2.16-3.43-2.98l-2.978-.893A9.725 9.725 0 0 1 168 30.028v7.438a16.737 16.737 0 0 0 6.38 1.313c3.43 0 4.473-.894 4.473-2.384z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M168 6v14.2c1.85-1.887 5.015-2.9 9.026-2.9 2.078 0 5.49.746 6.974 1.79V24h-.594c-1.484-.9-4.6-1.343-6.677-1.343s-3.86.6-3.86 2.087.928 1.94 1.93 2.235l2.967.893c3.41 1.043 7.716 2.235 7.716 8.2 0 4.918-3.71 8.048-11.13 8.048a18.724 18.724 0 0 1-6.354-1.2V56h32V6z"
}));

function SvgBarnesLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 62",
    fill: "currentColor",
    className: "sign-in__logo",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Barnes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarnesLogo);
export default __webpack_public_path__ + "static/media/barnesLogo.9b4470b9.svg";
export { ForwardRef as ReactComponent };